const items = document.querySelectorAll('.timeline__list-item');
const container = document.querySelector('.timeline__container');
const mediaQueryCondition = window.matchMedia('( min-width: 767px )');
const padding = 24;

export const timelineHeight = () => {
  let isEven = true;

  items.forEach(item => {
    if (isEven) {
      item.classList.add('even');
    } else {
      item.classList.add('odd');
    }
    isEven = !isEven;
  });

  const evenItems = document.querySelectorAll('.timeline__list-item.even');
  const oddItems = document.querySelectorAll('.timeline__list-item.odd');

  const getMaxHeight = items => {
    const sortedHeights = [...items]
      .map(item => item.getBoundingClientRect().height)
      .sort((a, b) => b - a);

    return sortedHeights[0];
  };

  const maxEvenHeight = getMaxHeight(evenItems) + padding;
  const maxOddHeight = getMaxHeight(oddItems);
  const totalHeight = maxEvenHeight + maxOddHeight;

  function handleMediaQuery(e) {
    if (e.matches) {
      container.style.height = `${totalHeight}px`;
    } else {
      container.style.height = `auto`;
    }
  }

  mediaQueryCondition.addListener(handleMediaQuery);
  handleMediaQuery(mediaQueryCondition);
};
